
<template>

	<myframe without_border without_margin title="Индивидуальный расчет">

		<biTable class="mt-4" :data="rows">
			<template v-slot:value_params="row">
				<router-link v-if="row.data.title == 'Модель оценки КС'" :to="row.data.value.url">{{ row.data.value.full_name }}</router-link>
			</template>
		</biTable>

	</myframe>

</template>

<script>

import api from "../../../../../api";
import myframe from "../../../../widgets/frame"
import biTable from "../../../../widgets/bi-table"

export default
{
	components :
	{
		myframe,
		biTable,
	},

	props :
	{
		version : Object,
	},

	data()
	{
		return {

		}
	},

	computed:
	{
		rows() {
			return [
				{ title: 'УПКС', value : api.format_cost(this.version.attrs.UPKS) },
				{ title: 'Кадастровая стоимость', value : api.format_cost(this.version.attrs.cost) },
				{ title: 'Модель', value : this.version.attrs.method_name },
				{
					title: 'Модель оценки КС',
					value :
					{
						url : '/cost_evaluations/' + this.version.group.id + '/individual',
						full_name : 'Индивидуальный расчет'
					},
					params : true
				},
			]
		},
	},

	methods :
	{
	}
}

</script>

